export default __webpack_public_path__ + "static/media/hanzo.2a0196fe.webp";